import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Group } from '../models/group';
import { Plant } from '../models/plant';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class DefectConfigurationService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  // hardCodeToken: string = environment.token;

  constructor(private http: HttpClient) { }

  //NOT IN USE
  // addDefects(data: any): Observable<Group[]> {
  //   return this.http.post<Group[]>(this.kpibaseUrl + 'defects', data);
  // }

  // getGroupData(data:any): any {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
  //   return this.http.post<any[]>(this.baseUrl + 'DMS/GetDefectTypeDDL', data, {headers: header} );
  // }

  getGroupData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    //const token = this.hardCodeToken ;//localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetGroup', data, {
      headers: header,
    });
  }

  getPlantsData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetDepartments', data);
  }
  // getPlantData(data:any): any {
  //   const token = localStorage.getItem('token');
  //     const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
  //     return this.http.get<any[]>(this.baseUrl + 'DMS/GetPlantByEgDDL', { headers: header, params: { Id: data.Id} });
  // }

  getUnitByLine(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<any[]>(this.O3CoreApiUrl + 'DMS/GetUnitByLine', {
      headers: header,
      params: { Id: data.Id },
    });
  }

  getDefectTypeDLL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/GetDefectTypeDDL', data, {
      headers: header,
    });
  }

  getSubDefectTypeDLL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'DMS/GetSubDefectTypeDDL',
      data,
      { headers: header }
    );
  }

  GetDefectPriorityDDL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'DMS/GetDefectPriorityDDL',
      data,
      { headers: header }
    );
  }

  GetDefectStatusDDL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'DMS/GetDefectStatusDDL',
      data,
      { headers: header }
    );
  }

  GetDefectClassificationDDL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'DMS/GetDefectClassificationDDL',
      data,
      { headers: header }
    );
  }

  GetDefectData(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/GetDefectData', data, {
      headers: header,
    });
  }

  getDefectfiles(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/GetDefectfiles', data, {
      headers: header,
    });
  }

  deleteDefectFiles(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/DeleteDefectFiles', data, {
      headers: header,
    });
  }

  addDefectfiles(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/AddDefectFiles', data, {
      headers: header,
    });
  }

  getMappedSubDefectType(data:any):Observable<any[]>
  {
   return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/getMappedSubDefectType' , data);
  }

  SaveDefectData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/InsertDefectData', data, {
      headers: header,
    });
  }

  UpdateDefectData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/UpdateDefectData', data, {
      headers: header,
    });
  }

  getCompModalTree(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/GetCompModelTree', data, {
      headers: header,
    });
  }

  // deleteDefect(data: any): Observable<any[]> {
  //   let params = new HttpParams().set('id', data);
  //   return this.http.post<any[]>(this.baseUrl + 'DMS/DeleteDefectData', {
  //     params: params,
  //   });
  // }
  deleteDefect(data: any): Observable<any[]> {
    const param = new HttpParams().set('id', data);
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'DMS/DeleteDefectData?' + param,
      { params: param }
    );
  }

  EmailDefectData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DMS/EmailDefectData', data);
  }

  getDefects(): Observable<Group[]> {
    return this.http.get<Group[]>(this.O3CoreApiUrl + 'Defect/GetAllDefects');
  }

  getDefectReports(data: any): Observable<Group[]> {
    return this.http.post<Group[]>(this.O3CoreApiUrl + 'Defect/GetDefectReports', data);
  }

  //NOT IN USE
  // getProducts(data: any): Observable<Group[]> {
  //   return this.http.post<Group[]>(this.kpibaseUrl + 'unitproduct', data);
  // }

   //NOT IN USE
  // getProductsData(data: any): Observable<Group[]> {
  //   return this.http.post<Group[]>(this.kpibaseUrl + 'products', data);
  // }

  //NOT IN USE
  // getParameters(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.kpibaseUrl + 'parametergroups', data);
  // }

  //NOT IN USE
  // machineParameters(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.O3CoreApiUrl + 'Defect/GetMachineParameters', data);
  // }

  //NOT IN USE
  // addMachineParameters(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.kpibaseUrl + 'defectparameter', data);
  // }

  setDefectClosed(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/SetDefectClosed', data);
  }
}
